import { Injectable } from '@angular/core';
import {
    EmployeeSubTitleResolverInterface,
    SubTitleMap,
} from '@app/components/platform/employee-autocomplete/employee-autocomplete.component';
import { AssignableSlot } from '@app/modules/documents-v2/interfaces/assignable-slot.interface';
import { EmployeeTemplateCustomFieldsQueryService } from '@app/modules/documents-v2/services/employee-template-custom-fields-query.service';
import { SigningTemplateSlot } from '@models/documents/signing-template-slot.model';
import { SigningTemplate } from '@models/documents/signing-template.model';
import { Employee } from '@models/employee/employee.model';

@Injectable({
    providedIn: 'root',
})
export class CustomFieldsTemplateQueryService implements EmployeeSubTitleResolverInterface {
    constructor(
        private query: EmployeeTemplateCustomFieldsQueryService,
        private template: SigningTemplate | null,
        private slot: SigningTemplateSlot
    ) {}

    async resolve(employees: Employee[]): Promise<SubTitleMap> {
        const results = await this.query.query(this.template, employees, this.slot);

        const result: { [key: string]: string } = {};
        employees.forEach((employee: Employee) => {
            const values = results[employee.id];
            const completed = values.filter((values: AssignableSlot) => values.hasValue).length;
            if (values.length) {
                result[employee.id] = completed + '/' + values.length + ' custom fields';
            }
        });

        return Promise.resolve(result);
    }
}
